<label class="form-label">{{ label }}</label>
<div class="row">
  <div class="col">
    <app-color #color (change)="onChange()"></app-color>
  </div>
</div>
